import React from "react";

const Card = ({ hotspot, setisHotspot }) => {
  return (
    <div className="card-container-rod">
      <div className="card-container-rod-name">{hotspot.name}</div>
      <div className="card-container-rod-category">{hotspot.category}</div>
      <div className="card-container-rod-address">{hotspot.address}</div>
      <div className="card-container-rod-info">{hotspot.info}</div>
      {hotspot.social !== "" && (
        <>
          <a
            className="card-container-rod-social"
            href={hotspot.social}
            target="_blank"
            rel="noreferrer"
          >
            LINK
          </a>
        </>
      )}
      <div className="card-container-rod-extra">{hotspot.extra}</div>
      <div
        className="card-container-rod-number"
        onClick={() => setisHotspot(hotspot)}
      >
        {hotspot.number}
      </div>
    </div>
  );
};

export default Card;
